import React from 'react';
import { useShowController } from 'react-admin';
import { Box, Typography } from '@material-ui/core';
import { List, Datagrid, TextField, FunctionField, DateField, Pagination } from 'react-admin';
import useStyles from './styles';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import LaptopIcon from '@material-ui/icons/Laptop';
import TabletIcon from '@material-ui/icons/Tablet';
import DevicesIcon from '@material-ui/icons/Devices';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { IconButton, Tooltip, Chip } from '@material-ui/core';
import EmptyState from '../EmptyState';

const DeviceTypeChip = ({ record }) => {
    const classes = useStyles();
    const os = record.baseOs?.toLowerCase() || '';
  
    let icon = <DevicesIcon fontSize="small" />;
    let chipClass = classes.deviceChip;
  
    if (os.includes('android')) {
      icon = <PhoneAndroidIcon fontSize="small" />;
    } else if (os.includes('ios') || os.includes('iphone') || os.includes('apple')) {
      icon = <PhoneIphoneIcon fontSize="small" />;
    } else if (os.includes('windows') || os.includes('mac') || os.includes('osx')) {
      icon = <LaptopIcon fontSize="small" />;
    } else if (os.includes('ipad') || os.includes('tablet')) {
      icon = <TabletIcon fontSize="small" />;
    }
  
    return (
      <Chip
        icon={icon}
        label={record.baseOs || 'Unknown'}
        size="small"
        className={chipClass}
      />
    );
  };

  const CopyableTokenField = ({ record }) => {
    const token = record.deviceToken || '';
    const truncated = token.length > 12 ? `${token.slice(0, 6)}...${token.slice(-4)}` : token;
    const handleCopy = () => navigator.clipboard.writeText(token);
  
    return (
      <Box display="flex" alignItems="center">
        <Typography variant="body2">{truncated}</Typography>
        <Tooltip title="Copy">
          <IconButton size="small" onClick={handleCopy}>
            <FileCopyIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    );
  };


const DevicesTab = props => {
    const { record, basePath } = useShowController(props);
    const classes = useStyles();
    if (!record) return null;
    return (
       <Box>
         <Typography variant="h6" className={classes.sectionTitle}>
            Хэрэглэгчийн төхөөрөмжүүд
          </Typography>
          <List
            component="div"
            resource="userDevices"
            basePath={basePath}
            filter={{ userId: record.id }}
            sort={{ field: 'updatedAt', order: 'DESC' }}
            bulkActionButtons={false}
            perPage={25}
            pagination={<Pagination />}
            exporter={false}
            actions={false}
            empty={<EmptyState message="No devices registered for this user" />}
          >
            <Datagrid className={classes.deviceTable}>
              <TextField source="macAddress" label="MAC Address" />
              <FunctionField label="OS" render={record => <DeviceTypeChip record={record} />} />
              <TextField source="apiLevel" label="API Level" />
              <TextField source="deviceId" label="Device ID" />
              <FunctionField label="Device Token" render={record => <CopyableTokenField record={record} />} />
              <TextField source="appVersion" label="App Version" />
              <DateField source="createdAt" label="Created At" showTime />
              <DateField source="updatedAt" label="Updated At" showTime />
            </Datagrid>
          </List> 
       </Box>
    );
  };

export default DevicesTab;